import React from "react";
import { Box } from "@mui/material"
import { useState, useRef, useCallback, useEffect } from "react";
import { keyframes } from "@mui/system";
import { isDarkMode } from "../../utils/constants"
import { handleSharing } from "../../utils/share";
import RefreshDataDark from '../../images/RefreshDataDark.png'
import ShareButtonDark from '../../images/ShareButtonDark.png'
import RefreshData from '../../images/RefreshData.png'
import ShareButton from '../../images/ShareButton.png'
import WatchButtonDark from '../../images/WatchButtonDark.png'
import WatchButton from '../../images/WatchButton.png'
import PaywallSelectCheck from '../../images/PaywallSelectCheck.png'
import WatchlistUpdate from '../../images/WatchlistUpdate.png'
import ReportError from '../../images/ReportError.png'
import ReportErrorDark from '../../images/ReportErrorDark.png'
import { updateUserWatchlist, userShareExperienceButton } from '../../api/user'
import { ReportModal } from '../ReportModal';
import { useNavigate } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { isMobileBrowser } from "../../utils/user_agent";
import { useAppContext } from "../../contexts/AppContext";
import { useChatContext } from "../../contexts/ChatContext";
import { get_max_watchlist_items } from "../../utils/constants";
import CheckIcon from '@mui/icons-material/Check';
import { Fade, Tooltip } from '@mui/material';
import { getDenomination } from "./Charting/utils";
import { copyContent } from "../../utils/Copy";
import { formatPriceUpdatedAt, railsToIana } from "../../utils/timezones";

const CopyActionButton = React.memo(({ message }) => {
  const copyTimeoutRef = useRef(null);
  const [copying, setCopying] = useState(false);

  const handleCopy = useCallback(() => {
    copyContent(copyTimeoutRef, setCopying, message);
  }, [message]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        color: isDarkMode ? '#fff' : '#000',
        fontSize: '13px',
        '&:hover': { cursor: 'pointer' },
      }}
      onClick={handleCopy}
    >
      <Tooltip title="Copy">
        <Box
          sx={{
            position: 'relative',
            height: 24,
            width: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Fade in={!copying} timeout={200} unmountOnExit>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ContentCopyIcon sx={{ fontSize: 16 }} />
            </Box>
          </Fade>
          <Fade in={copying} timeout={200} unmountOnExit>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CheckIcon sx={{ fontSize: 16 }} />
            </Box>
          </Fade>
        </Box>
      </Tooltip>
    </Box>
  );
});

CopyActionButton.displayName = "CopyActionButton";

const formatDisplayPrice = (value, assetType) => {
  if (value == null || value === "") return "";
  const raw = String(value).replace(/,/g, "").trim();
  if (!raw) return "";
  const num = Number(raw);
  if (!Number.isFinite(num)) return String(value);

  const isCryptoOrFx = assetType === "cryptos" || assetType === "forex";
  const decimalPlaces = raw.includes(".") ? raw.split(".")[1].length : 0;
  const maxFractionDigits = isCryptoOrFx
    ? Math.max(2, Math.min(decimalPlaces || 2, 8))
    : 2;

  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFractionDigits,
  });
};

const displayDataDropIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const livePriceFlashUp = keyframes`
  0% {
    background-color: rgba(24, 128, 56, 0.2);
    box-shadow: 0 0 0 0 rgba(24, 128, 56, 0.18);
  }
  100% {
    background-color: rgba(24, 128, 56, 0);
    box-shadow: 0 0 0 10px rgba(24, 128, 56, 0);
  }
`;

const livePriceFlashDown = keyframes`
  0% {
    background-color: rgba(227, 66, 52, 0.2);
    box-shadow: 0 0 0 0 rgba(227, 66, 52, 0.16);
  }
  100% {
    background-color: rgba(227, 66, 52, 0);
    box-shadow: 0 0 0 10px rgba(227, 66, 52, 0);
  }
`;

const parseLivePriceNumber = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const cleaned = String(value).replace(/,/g, "").trim();
  if (!cleaned) return null;

  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
};

const DisplayData = (props) => {
  const { appProps, setIsRefreshing } = useAppContext();
  const { loadingResponse } = useChatContext();

  const { 
    messageThread, isLastMessage, showAddWatchlist, displayUpdatedInfo, preventQuestionInput, setPreventQuestionInput, secondaryExperienceType, onQuestionSubmit,
    setModalVisible, setShowChatShare, isLoggedIn, countOfWatchlistTicker, setShowAddWatchlist,
    freeUnlimitedOnly, hasShownFreeUnlimitedMessage,
    onTickerSelect, selectedTickerId, isChartLoading,
    chartMessageThread,
    questionNumber,
    showTopActions = true,
    outerMarginTop = "7px",
    contentMarginTop = "20px",
  } = props

  const { setShowWatchlistBlueDot, setShowWatchlistFlicker, userData, setUserData } = appProps


  const [showReportModal, setShowReportModal] = useState(false)
  const [showAddingWatchlist, setShowAddingWatchlist] = useState(false)
  const [showAddedatchlist, setShowAddedatchlist] = useState(false)
  const [watchlistCountError, setWatchlistCountError] = useState(false)
  const navigate = useNavigate()

  const isMobile = isMobileBrowser();
  const hasAccount = Boolean(
    userData?.user_account_info && Object.keys(userData.user_account_info).length > 0
  );
  const proTrialDays = Number(userData?.pro_trial_days) > 0 ? Number(userData.pro_trial_days) : 7;
  const canStartProTrial = !hasAccount || userData?.eligible_for_pro_trial !== false;
  const freeLimitCtaLabel = canStartProTrial
    ? `Start ${proTrialDays}-Day Free Trial`
    : "Upgrade to Pro";


  const currentPriceValue =
    displayUpdatedInfo?.currentPriceValue ?? displayUpdatedInfo?.currentPrice;
  const closePriceValue =
    displayUpdatedInfo?.closePriceValue ?? displayUpdatedInfo?.closePrice;
  const isAfterHours =
    closePriceValue != null && closePriceValue !== "";
  const assetType = (displayUpdatedInfo && displayUpdatedInfo.assetType) || messageThread.assetType
  const is24hrMarket = (assetType == "cryptos" || assetType == "forex")
  const denomination = getDenomination(assetType)
  const userTimezone = railsToIana(userData?.user_account_info?.timezone)
  const hasPrice = currentPriceValue != null && currentPriceValue !== "";
  const updatedAtLabel = formatPriceUpdatedAt(
    displayUpdatedInfo?.currentPriceUpdatedAt,
    displayUpdatedInfo?.currentPriceUpdatedAtIso,
    userTimezone,
  )
  const hasUpdatedAt = !!updatedAtLabel;
  const showPriceBlock = !freeUnlimitedOnly && (hasPrice || hasUpdatedAt || isChartLoading);
  const livePriceNumber = parseLivePriceNumber(currentPriceValue);
  const priorLivePriceRef = useRef(livePriceNumber);
  const flashTimeoutRef = useRef(null);
  const [livePriceFlashDirection, setLivePriceFlashDirection] = useState(null);

  useEffect(() => {
    priorLivePriceRef.current = livePriceNumber;
    setLivePriceFlashDirection(null);
    if (flashTimeoutRef.current) {
      clearTimeout(flashTimeoutRef.current);
      flashTimeoutRef.current = null;
    }
  }, [selectedTickerId]);

  useEffect(() => {
    if (livePriceNumber == null) return;

    const priorValue = priorLivePriceRef.current;
    if (priorValue != null && livePriceNumber !== priorValue) {
      setLivePriceFlashDirection(livePriceNumber > priorValue ? "up" : "down");
      if (flashTimeoutRef.current) {
        clearTimeout(flashTimeoutRef.current);
      }
      flashTimeoutRef.current = window.setTimeout(() => {
        setLivePriceFlashDirection(null);
        flashTimeoutRef.current = null;
      }, 850);
    }

    priorLivePriceRef.current = livePriceNumber;
  }, [livePriceNumber]);

  useEffect(() => {
    return () => {
      if (flashTimeoutRef.current) {
        clearTimeout(flashTimeoutRef.current);
      }
    };
  }, []);

  const livePriceAccentColor =
    livePriceFlashDirection === "up"
      ? "#188038"
      : livePriceFlashDirection === "down"
        ? "#E34234"
        : isDarkMode
          ? "#F9F9F9"
          : "#000";
  const livePriceAnimation =
    livePriceFlashDirection === "up"
      ? `${livePriceFlashUp} 850ms ease-out`
      : livePriceFlashDirection === "down"
        ? `${livePriceFlashDown} 850ms ease-out`
        : "none";

  const tickerDescriptions = messageThread.tickerDescription || [];
  const tickerIds = messageThread.answeredTickerIds || [];
  const tickerSymbolsArray = Array.isArray(messageThread.ticker)
    ? messageThread.ticker
    : messageThread.ticker
    ? [messageThread.ticker]
    : [];
  
  const logoUrls = chartMessageThread.logoUrls

  return (
    <Box className="answer-description-text" sx={{
      marginTop: outerMarginTop,
      color: isDarkMode ? '#848484' : '#888888',//'#B7B7B7',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '6px',
      animation: `${displayDataDropIn} 220ms ease-out`,
      willChange: "transform, opacity",
      "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
      },
      }}>
      { (showTopActions && isLastMessage && !loadingResponse) &&
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{display: 'flex', flexDirection: false ? 'column':'row', gap: '20px'}}>
            <Box sx={{display: 'flex', gap: '20px', marginLeft: false ? '6px':'unset'}}>
              { (messageThread.tickerDescription && messageThread.tickerDescription.length > 0) &&
              <Box sx={{marginLeft: '6px', display: 'flex', alignItems: 'center', gap: '20px', color: isDarkMode ? '#fff':'#000', fontSize: '13px', '&:hover': {cursor: 'pointer'}}}
                onClick={() => {
                  handleSharing(setModalVisible, setShowChatShare, true)
                }}
              >
                <Tooltip title="Share">
                  <img src={isDarkMode ? ShareButtonDark : ShareButton} style={{maxHeight: '16px'}} />
                </Tooltip>
              </Box>
              }
              { showAddWatchlist && <>
                { messageThread.answeredTickerIds.length > 0 &&
                  <Box sx={{position: 'relative', display: 'flex', alignItems: 'center', gap: '5px', color: isDarkMode ? '#fff':'#000', fontSize: '13px', '&:hover': {cursor: 'pointer'}}}
                    onClick={() => {
                      if (isLoggedIn) {
                        if (userData && userData.has_active_subscription) {
                          const intIds = messageThread.answeredTickerIds.map(v => parseInt(v))
                          if (countOfWatchlistTicker + intIds.length > get_max_watchlist_items(userData)) {
                            setWatchlistCountError(true)
                            setTimeout(() => {
                              setWatchlistCountError(false)
                            }, 4000)
                          } else {
                            setWatchlistCountError(false)
                            updateUserWatchlist(intIds, null, appProps.setWatchlistData, setIsRefreshing)
                            setShowAddingWatchlist(true)
                            setShowWatchlistBlueDot(true)
                            setShowWatchlistFlicker(true)
                            setTimeout(() => {
                              setShowAddingWatchlist(false)
                              setShowAddedatchlist(true)
                            }, 1300)
                            setTimeout(() => {
                              setShowAddWatchlist(false)
                            }, 2600)
                            setTimeout(() => {
                              setShowWatchlistFlicker(false)
                              setShowAddedatchlist(false)
                            }, 5000)
                          } 
                        } else {
                          // Show paywall with custom message
                          // appProps.setPaywallMessage(watchlistPaywallModalMessage)
                          // appProps.setShowPaywallModal(true)
                          navigate('/plan-selection')
                        }

                      } else {
                        appProps.setShowSignUpModal(true)
                      }
                    }}
                  >
                    { showAddingWatchlist ? 
                    
                      <> 
                        <Tooltip title="Add Watchlist">
                          <img src={WatchlistUpdate} style={{maxHeight: '16px'}} className={"rotate-animation"} />
                          </Tooltip>
                      </>
                      :
                      <>
                       <Tooltip title="Add Watchlist">
                          <img src={showAddedatchlist ? PaywallSelectCheck : (isDarkMode ? WatchButtonDark : WatchButton)} style={{maxHeight: '16px'}} />
                        </Tooltip> 
                       </>
                    }
                    { watchlistCountError &&
                      <Box sx={{position: 'absolute', border: '#F6F6F6', backgroundColor: isDarkMode ? '#131521' : '#F6F6F6', left: '-86px', width: '272px', top: isMobile ? '-50px':'25px', borderRadius: '8px', display: 'flex', flexDirection: 'column', gap: '6px', padding: '0px', }}>
                        <Box sx={{ border: '#F6F6F6', backgroundColor: isDarkMode ? '#131521' : '#F6F6F6', borderRadius: '8px', padding: '7px' }}>
                          <span className={isDarkMode ? "base-text dark" : "base-text"} style={{fontSize: '12px'}}>
                          {`You can only have ${get_max_watchlist_items(userData)} items at a time in your watchlist. Please remove to add more.`}
                          </span>
                        </Box>
                      </Box>
                    }
                  </Box>
                }
                </>
              }
              { (messageThread.tickerDescription && messageThread.tickerDescription.length > 0) &&
              <Box sx={{display: 'flex', alignItems: 'center', gap: '5px', color: isDarkMode ? '#fff':'#000', fontSize: '13px', '&:hover': {cursor: 'pointer'}}}
                onClick={() => {
                  if (!preventQuestionInput) {
                    setPreventQuestionInput(true)
                    setTimeout(() => {
                      if (!secondaryExperienceType || secondaryExperienceType == "new-user") {
                        onQuestionSubmit("Update")
                      } else if (secondaryExperienceType == "ask-share") {
                        if (questionNumber == 1) {
                          handleSharing(setModalVisible, setShowChatShare, false)
                          setTimeout(() => {
                            setUserData({...userData, showAskShareMessage: false})
                          }, 1500)
                          setPreventQuestionInput(false)
                          userShareExperienceButton("share")
                        } else {
                          setUserData({...userData, showAskShareMessage: false})
                          setPreventQuestionInput(false)
                          userShareExperienceButton("continue")
                        }
                      }
                    }, 50)
                  }
                }}
              >

                <Tooltip title="Refresh">
                  <img src={isDarkMode ? RefreshDataDark : RefreshData} style={{marginTop: '1px', maxHeight: '16px'}} />
                </Tooltip>
              </Box>
              }
            </Box>

            <Box sx={{display: 'flex', gap: '20px' }}>
              <CopyActionButton message={messageThread?.message} />
              <Box sx={{display: 'flex', alignItems: 'center', gap: '5px', color: isDarkMode ? '#fff':'#000', fontSize: '13px', '&:hover': {cursor: 'pointer'}}}
                onClick={() => {
                  setShowReportModal(true)
                }}
              >
                <Tooltip title="Report">
                  <img src={isDarkMode ? ReportErrorDark : ReportError} style={{marginTop: '1px', maxHeight: '16px'}} />
                </Tooltip>
          
              </Box>

              { showReportModal &&
                <ReportModal setShowReportModal={setShowReportModal}/>
              }
            </Box>

          </Box>
        </Box>
      }
      <Box sx={{
        marginTop: contentMarginTop,
        marginRight: "auto",
        marginBottom: "auto",
        marginLeft: "0px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}>
        {/* {messageThread.tickerDescription && (messageThread.tickerDescription.length < 2 */}
        {messageThread.tickerDescription && (true
        ?
        <Box sx={{display: 'flex', alignItems: 'center'}}>
        { !isDarkMode && logoUrls && logoUrls.length > 0 &&
          <div style={{height: '32px', marginRight: '8px'}}>
            { logoUrls[0] && 
                <img src={`${logoUrls[0]}`} style={{maxHeight: '100%', mixBlendMode: "multiply"}}/>
            }
          </div>
        }
        <Box>
        {!freeUnlimitedOnly &&
          tickerDescriptions.map((td, idx) => {
            const tickerId = tickerIds[idx];
            const tickerSymbol = tickerSymbolsArray[idx] || tickerSymbolsArray[0];
            const showSymbol =
              tickerDescriptions.length <= 1 &&
              hasPrice &&
              tickerSymbol;
            const label = showSymbol ? `${td}  (${tickerSymbol})` : td;
            const normalizedTickerId = tickerId != null ? String(tickerId) : null;
            const isSelected =
              normalizedTickerId &&
              selectedTickerId &&
              normalizedTickerId === selectedTickerId;
            if (!isSelected) return null; // if we ever want to show all the names, we can.
            const clickable = typeof onTickerSelect === "function" && tickerId;

            return (
              <span
                key={`${td}-${tickerId ?? idx}`}
                onClick={() => clickable && onTickerSelect(tickerId)}
                style={{
                  fontSize: isMobile ? 20 : 22,
                  color: isSelected ? (isDarkMode ? "#68a0ff" : "#606368") : undefined,
                  fontWeight: isSelected ? 700 : 400,
                  marginTop: "2px",
                  cursor: clickable ? "pointer" : "default",
                }}
              >
                {label}
                {/* {isSelected && isChartLoading && (
                  <span style={{ marginLeft: "6px", fontSize: "11px" }}>Loading...</span>
                )} */}
                {/* {idx < tickerDescriptions.length - 1 ? " | " : ""} */}
              </span>
            );
          })}
        { showPriceBlock && (
          <>
            { hasPrice ? (
              (isAfterHours && !is24hrMarket) ?
                <>
                <Box sx={{marginTop: '6px'}}>
                  {`Close Price: `}{`${denomination}${formatDisplayPrice(closePriceValue, assetType)}`}
                  { displayUpdatedInfo.pricePctChange1d != null &&
                    <span style={{color: parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? '#188038' : '#E34234', opacity: parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? 1.0 : 0.75}}>
                      {` (${parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? '+':''}${Math.round(100*parseFloat(displayUpdatedInfo.pricePctChange1d))/100}%)`}
                    </span>
                  }
                </Box>
                { (displayUpdatedInfo.pricePctChangeAh != null) &&
                <>
                  {`After hours: `}
                  <Box
                    component="span"
                    sx={{
                      display: "inline-flex",
                      alignItems: "baseline",
                      borderRadius: "9px",
                      px: "6px",
                      py: "2px",
                      mr: "2px",
                      color: livePriceAccentColor,
                      animation: livePriceAnimation,
                      transition: "color 120ms ease-out",
                      "@media (prefers-reduced-motion: reduce)": {
                        animation: "none",
                        transition: "none",
                      },
                    }}
                  >
                    <b>{`${denomination}${formatDisplayPrice(currentPriceValue, assetType)}`}</b>
                  </Box>
                  <span style={{color: parseFloat(displayUpdatedInfo.pricePctChangeAh) >= 0 ? '#188038' : '#E34234', opacity: parseFloat(displayUpdatedInfo.pricePctChangeAh) >= 0 ? 1.0 : 0.75}}>
                    {` (${parseFloat(displayUpdatedInfo.pricePctChangeAh) >= 0 ? '+':''}${Math.round(100*parseFloat(displayUpdatedInfo.pricePctChangeAh))/100}%)`}
                  </span>
                </>
                }
                </>
              :
                <Box sx={{marginTop: '6px', color: isDarkMode ? '#F9F9F9' : '#000', fontSize: 16, fontWeight: '500', minHeight: '22px'}}>
                  <Box
                    component="span"
                    sx={{
                      display: "inline-flex",
                      alignItems: "baseline",
                      borderRadius: "9px",
                      px: "6px",
                      py: "2px",
                      mr: "2px",
                      color: livePriceAccentColor,
                      animation: livePriceAnimation,
                      transition: "color 120ms ease-out",
                      "@media (prefers-reduced-motion: reduce)": {
                        animation: "none",
                        transition: "none",
                      },
                    }}
                  >
                    <b>{`${formatDisplayPrice(currentPriceValue, assetType)} USD`}</b>
                  </Box>
                  { (displayUpdatedInfo.pricePctChange1d != null && displayUpdatedInfo.pricePctChange1d != "f") &&
                    <>
                      { false ?//is24hrMarket ?
                        <span style={{color: parseFloat(displayUpdatedInfo.pricePctChange24hr) >= 0 ? '#188038' : '#E34234', opacity: parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? 1.0 : 0.75}}>
                        {/* {` (${parseFloat(displayUpdatedInfo.pricePctChange24hr) >= 0 ? '+':''}${Math.round(10000*parseFloat(displayUpdatedInfo.pricePctChange24hr))/100}% last 24hrs)`} */}
                        {/*  NOTE, making life easier now to align with the live charts; no longer showing last 24 hours, just the price change from prior bar. */}
                        {` (${parseFloat(displayUpdatedInfo.pricePctChange24hr) >= 0 ? '+':''}${Math.round(100*parseFloat(displayUpdatedInfo.pricePctChange24hr))/100}%)`}
                        </span>
                      :
                        <span style={{color: parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? '#188038' : '#E34234', opacity: parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? 1.0 : 0.75}}>
                          {` (${parseFloat(displayUpdatedInfo.pricePctChange1d) >= 0 ? '+':''}${Math.round(100*parseFloat(displayUpdatedInfo.pricePctChange1d))/100}%)`}
                        </span>
                      }
                    </>
                  }
                </Box>
            ) : (
              <Box sx={{marginTop: '6px', color: isDarkMode ? '#F9F9F9' : '#000', fontSize: 16, fontWeight: '500', opacity: 0.5, minHeight: '22px'}}>
                Loading price...
              </Box>
            )}
            { isLastMessage && 
              <Box sx={{marginTop: '4px', opacity: hasUpdatedAt ? 1.0 : 0.6, minHeight: '18px'}}>
                Last updated: {hasUpdatedAt ? updatedAtLabel : "--"}
              </Box>
            }
          </>
        )}
        </Box>
        </Box>
        :
        <Box>
          {`${messageThread.tickerDescription.length} investments analyzed`}
          { updatedAtLabel &&
            <Box sx={{marginTop: '4px'}}>
              Last updated: {updatedAtLabel}
            </Box>
          }
        </Box>
      
        )}
      </Box>
      {
          freeUnlimitedOnly && (
            hasShownFreeUnlimitedMessage ? (
              <Box sx={{ marginTop: '20px' }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '32px',
                  minWidth: '86px',
                  width: 'auto',
                  px: '14px',
                  borderRadius: '26px',
                  whiteSpace: 'nowrap',
                  color: 'white',//isDarkMode ? 'black' : '#f5f5f5',
                  backgroundColor: '#5390E6',//isDarkMode ? '#f5f5f5' : 'black',
                  '&:hover': { cursor: 'pointer' }
                }} onClick={() => {
                  if (hasAccount) {
                    navigate('/plan-selection');
                  } else {
                    navigate('/register');
                  }
                }}>
                  {freeLimitCtaLabel}
                </Box>
              </Box>
            ) : (
              <Box sx={{
                marginTop: '18px',
                maxWidth: '250px',
                border: '1px solid gray',
                borderRadius: '10px',
                padding: '16px',
              }}>
                <Box className="base-text" style={{ color: isDarkMode ? 'white' : 'black', fontSize: '12px', fontWeight: 600, marginBottom: '10px', }}>
                  You have 1 message remaining today.
                </Box>
                <Box className="base-text" style={{ color: isDarkMode ? 'white' : 'black', fontSize: '12px', fontWeight: 400, }}>
                  Start a Pro trial to keep going today.
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '14px' }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '32px',
                    minWidth: '178px',
                    width: 'auto',
                    px: '14px',
                    borderRadius: '26px',
                    whiteSpace: 'nowrap',
                    color: 'white',//isDarkMode ? 'black' : 'white',
                    backgroundColor: '#5390E6',//isDarkMode ? 'white' : 'black',
                    '&:hover': { cursor: 'pointer' }
                  }} onClick={() => {
                    if (hasAccount) {
                      navigate('/plan-selection');
                    } else {
                      navigate('/register');
                    }
                  }}>
                    {freeLimitCtaLabel}
                  </Box>
                </Box>
              </Box>
            )
          )
        }
    </Box>
  )
}

const areEqualDisplayData = (prev, next) => {
  if (prev.messageThread !== next.messageThread) return false;
  if (prev.displayUpdatedInfo !== next.displayUpdatedInfo) return false;
  if (prev.selectedTickerId !== next.selectedTickerId) return false;
  if (prev.isLastMessage !== next.isLastMessage) return false;
  if (prev.showAddWatchlist !== next.showAddWatchlist) return false;
  if (prev.isLoggedIn !== next.isLoggedIn) return false;
  if (prev.countOfWatchlistTicker !== next.countOfWatchlistTicker) return false;
  if (prev.freeUnlimitedOnly !== next.freeUnlimitedOnly) return false;
  if (prev.hasShownFreeUnlimitedMessage !== next.hasShownFreeUnlimitedMessage)
    return false;
  if (prev.preventQuestionInput !== next.preventQuestionInput) return false;
  if (prev.secondaryExperienceType !== next.secondaryExperienceType) return false;
  if (prev.isChartLoading !== next.isChartLoading) return false;
  if (prev.chartMessageThread !== next.chartMessageThread) return false;
  if (prev.showTopActions !== next.showTopActions) return false;
  if (prev.outerMarginTop !== next.outerMarginTop) return false;
  if (prev.contentMarginTop !== next.contentMarginTop) return false;

  if (prev.onTickerSelect !== next.onTickerSelect) return false;
  if (prev.onQuestionSubmit !== next.onQuestionSubmit) return false;
  if (prev.setModalVisible !== next.setModalVisible) return false;
  if (prev.setShowChatShare !== next.setShowChatShare) return false;
  if (prev.setShowAddWatchlist !== next.setShowAddWatchlist) return false;
  if (prev.setPreventQuestionInput !== next.setPreventQuestionInput) return false;

  return true;
};

export default React.memo(DisplayData, areEqualDisplayData)
